import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryField } from 'shared/summary/SummaryField';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { BaseSummaryProps } from './types';


export const AltContactSummary = ({ application }: BaseSummaryProps) => {
  const steps = useRentalSteps({slug: slugs.altContact});
  const customer = application?.customer;
  const errors = application?.validation?.customer;
  const fields = ['altContactName', 'altContactPhone'];
  const isInvalid = !!errors?.find((e) => fields.indexOf(e.field) >= 0);

  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Alternative Contact</SummaryHeader>
      {!customer ? <LoadingLabel alignment="left" /> : (
        <>
          <SummaryField data={customer} label="Name" field="altContactName" errors={errors} />
          <SummaryField data={customer} label="Mobile number" field="altContactPhone" errors={errors} />
        </>
      )}
    </SummarySection>
  );
}